module.exports = __webpack_public_path__ + "img/pizzas.32163b64.jpg";